import {createUseStyles} from 'react-jss';

export default createUseStyles({
  title: {
    margin: [20, 20, 0, 20],
    fontSize: 18,
    fontStyle: 'italic',
    fontWeight: 700,
    color: '#5a5b5e',
  },
  logo: {
    height: 35,
    padding: [0, 6, 0, 0],
  },
  text: {
    marginBottom: 25,
    fontSize: 14,
  },
  container: {
    margin: 20,
  },
  button: {
    textAlign: 'center',
  },
});
